import React from 'react';
export const LegendAlertTriangleIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={24}
    height={18}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="9" r="9" fill="#EA3829" />
    <path
      d="M11.9993 14.1481C11.7225 14.1578 11.4528 14.0595 11.2474 13.874C10.851 13.4365 10.851 12.7701 11.2474 12.3326C11.4506 12.1426 11.7212 12.0412 11.9993 12.0509C12.283 12.0395 12.5584 12.1472 12.759 12.3478C12.9534 12.549 13.058 12.8204 13.0486 13.1C13.0635 13.3816 12.9651 13.6575 12.7754 13.8663C12.5671 14.0638 12.2859 14.1659 11.9993 14.1481Z"
      fill="white"
    />
    <path
      d="M12.0001 10.1C11.5032 10.1 11.1001 9.69687 11.1001 9.2V4.4C11.1001 3.90313 11.5032 3.5 12.0001 3.5C12.497 3.5 12.9001 3.90313 12.9001 4.4V9.2C12.9001 9.69687 12.497 10.1 12.0001 10.1Z"
      fill="white"
    />
  </svg>
);
